import React from "react";
import { TextField } from "@mui/material";

/**
 * Поле для кода из приложения-аутентификатора.
 *
 * Бэкенд принимает 6–8 символов, поэтому длину не режем жёстко до шести.
 * `inputMode="numeric"` поднимает цифровую клавиатуру на телефоне, но type
 * оставляем текстовым: у number-инпута есть стрелки и он молча глотает
 * ведущие нули, а код `012345` — валидный.
 */
const TotpCodeField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  label?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  onEnter?: () => void;
}> = ({
  value,
  onChange,
  label = "Код из приложения",
  autoFocus,
  disabled,
  error,
  helperText,
  onEnter,
}) => (
  <TextField
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/[^\dA-Za-z]/g, "").slice(0, 8))}
    onKeyDown={(e) => {
      if (e.key === "Enter" && onEnter) {
        e.preventDefault();
        onEnter();
      }
    }}
    autoFocus={autoFocus}
    disabled={disabled}
    error={error}
    helperText={helperText}
    fullWidth
    autoComplete="one-time-code"
    slotProps={{
      htmlInput: {
        inputMode: "numeric",
        maxLength: 8,
        style: {
          fontFamily: "monospace",
          fontSize: 22,
          letterSpacing: "0.4em",
          textAlign: "center",
        },
      },
    }}
  />
);

export default TotpCodeField;
